<template>
    <div style="height:100%">
        <video class="video-background" ref="videoPlayer" autoplay muted loop v-if="videoUrl">
            <source :src.sync="videoUrl" type="video/mp4">
        </video>
        <div class="classify-container" id="classifyContainer" @click="clickClassifyContainer">
            <div class="classify-left-menu">
                <classify-left-menu :isMember="isMember" :sex="sex" :active="active" :searchQuery="searchQuery" @clickItem="clickItem" @clickSetting="settingVisit = true" @clickAvatar="userVisit = true" />
            </div>
            <div class="classify-content">
                <div class="company_name">
                    <img src="../../static/image/logo.png" class="company_logo" />
                    <span>比创达EMC器件选型平台</span>
                </div>
                <div class="date-time-search">
                    <div class="date-time date-time-item">
                        <span>{{ currentTime }}</span>
                    </div>
                    <div class="current-date date-time-item">
                        <span>{{ currentDate }}</span>
                    </div>
                    
                    <el-input
                        v-model="searchQuery"
                        placeholder="请输入分类名称或需要查找的内容"
                        @input="changeInput"
                        @focus="onFocus"
                        @blur="onBlur"
                        @keyup.enter.native="clickInput"
                        class="search-box">
                        <template slot="suffix">
                            <i class="el-icon-close search-icon" @click="clearSearchQuery" v-if="searchQuery"></i>
                            <i class="el-icon-search search-icon" @click="clickInput"></i>
                        </template>
                    </el-input>
                    <div class="result_ul" v-if="searchQuery && searchQuery.length && showResultUl">
                        <ul>
                            <li @click="handleTranslationClick">
                                <img src="../../static/image/translation.png" />
                                翻译：{{searchQuery.length > 26 ? searchQuery.substring(0, 27) + '...' : searchQuery}}
                            </li>
                            <li v-for="item in resultList" @click="toBaidu(item)">
                                <i class="el-icon-search"></i>
                                {{item}}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="classify_body">
                    <div class="classify_container">
                        <website-tool v-if="active === '4'" ref="websiteToolRef" />
                        <div  class="classify_group" v-for="groupClassify in groupClassifies" v-if="active !== '4' && groupClassifies.length > 0">
                            <div class="title-text" style="color: #fff">
                                <i class="el-icon-price-tag" slot="titleName"></i>
                                <span>{{groupClassify.groupName}}</span>
                            </div>
                            <div class="classify_row">
                                <div class="classify-card" v-for="(item, index) in groupClassify.classifies" :key="index" @click="toNextLevel(item.id)">
                                    <img :src="createFilePath(item.fileName)" v-if="item.fileId">
                                    <div class="card-title">{{ item.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-empty :image-size="200" v-if="groupClassifies.length === 0 && active !== '4'"></el-empty>
                </div>
            </div>
        </div>
        <user-drawer :userVisit="userVisit" :isMember="isMember" @logout="logout" @changeSex="changeSex" @closeUserDrawer="closeUserDrawer" />
        <backgroundSettingDialog :settingVisit="settingVisit" @closeSetting="closeSetting" @refreshBackground="refreshBackground" />
    </div>
</template>
<script>
import TitleBar from '../../components/TitleBar.vue'
import ClassifyLeftMenu from './classifyLeftMenu.vue';
import backgroundSettingDialog from './backgroundSettingDialog.vue'
import UserDrawer from './UserDrawer.vue';
import loginImage from '../../static/image/login-image.png';
import websiteTool from './websiteTool'

export default {

    props: ['classifyId', 'type'],
    data() {
        return {
            groupClassifies: [],
            paramName: '',
            searchQuery: undefined,
            active: '1',
            isMember: false,
            currentTime: '',
            currentDate: '',
            resultList: [],
            showResultUl: false,
            settingVisit: false,
            videoUrl: undefined,
            userVisit: false,
            sex: 1,
            imgUrl: loginImage,
        }
    },
    created() {
        if (this.classifyId) {
            this.toNextLevel(this.classifyId)
        } else {
            this.getClassifyInfos()
        }
        if (this.hasToken) {
            this.exitMember()
        } else {
            this.isMember = true;
        }
        this.getUserSex();
    },
    computed: {
        hasToken() {
            return localStorage.getItem("token") !== null;
        }
    },
    mounted() {
        // 每秒更新一次时间
        this.updateDateTime();
        setInterval(this.updateDateTime, 1000);
        this.refreshBackground()
    },
    methods: {
        exitMember() {
            this.$api.get('/emcMember/exit').then(res => {
                this.isMember = res.data
            })
        },
        logout() {
            this.isMember = false;
        },
        getClassifyInfos() {
            let queryForm = {'type': this.type}
            if (this.searchQuery && this.searchQuery !== '') {
                queryForm.name = this.searchQuery
            }
            this.$api.get('/classifyInfo/listByParentId', queryForm).then(res => {
                if (res.data.length) {
                    this.groupClassifies = res.data
                } else {
                    this.toBaidu(this.searchQuery)
                }
            })
        },
        createFilePath(fileName) {
            return `${this.domain}${fileName}`
        },
        toNextLevel(id) {
            const path = this.type === 'ANALYSIS' ? '/analysisShowList' : this.type === 'STANDARD' ? '/standardShowList' : '/deviceShowList'            
            this.$router.push({path: path, query: {classifyId: id, 'isMember': true}});
        },
        clickInput() {
            this.showResultUl = false
            if (this.active === '4') {
                this.$refs.websiteToolRef.searchByName(this.searchQuery)
            } else {
                this.getClassifyInfos()
            }
        },
        changeInput(val) {
            const callbackName = 'jsonp_callback_' + new Date().getTime();
            const that = this;
            // 创建全局回调函数
            window[callbackName] = function(data) {
                that.resultList = [];
                if (data.s.length) {
                    for (let i = 0; i < data.s.length; i++) {
                        that.resultList.push(data.s[i]);
                    }
                    that.showResultUl = true;
                }
                // 清理回调函数，防止内存泄漏
                delete window[callbackName];
            };
            const oScript = document.createElement('script');
            oScript.src = `https://suggestion.baidu.com/su?wd=${encodeURIComponent(val)}&ie=utf-8&cb=${callbackName}`;
            document.body.appendChild(oScript);
        },
        onFocus() {
            if (this.resultList.length) {
                this.showResultUl = true;
            }
        },
        onBlur() {
            setTimeout(() => {
                this.showResultUl = false
            }, 100)
            // this.showResultUl = false;
        },
        clearSearchQuery() {
            this.searchQuery = '';
            this.resultList = [];
            this.clickInput()
        },
        handleTranslationClick() {
            window.open(`https://fanyi.baidu.com/mtpe-individual/transText?query=${this.searchQuery}#/`);
        },
        toBaidu(item) {
            window.open(`https://cn.bing.com/search?form=QBLH&q=${item}`);
        },
        clickItem(active) {
            if (this.active !== active) {
                this.active = active
                if (active !== '4') {
                    this.type = active === '1' ? undefined : active === '2' ? 'ANALYSIS' : 'STANDARD'
                    this.getClassifyInfos();
                }
            }
        },
        updateDateTime() {
            const date = new Date();
            const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            this.currentTime = `${hours}:${minutes}:${seconds}`;
            this.currentDate = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${weekDays[date.getDay()]}`;
        },
        closeSetting() {
            this.settingVisit = false;
        },
        closeUserDrawer() {
            this.userVisit = false;
        },
        refreshBackground () {
            this.videoUrl = localStorage.getItem('EMC_BACKGROUD_VIDEO');
            const container = document.getElementById('classifyContainer');
            if (this.videoUrl === null) {
                var imgUrl = localStorage.getItem('EMC_BACKGROUD_IMG')
                if (imgUrl === null) {
                    var color = localStorage.getItem('EMC_BACKGROUD_COLOR')
                    if (color !== null) {
                        container.style.background = color;
                        return;
                    } else {
                        imgUrl = this.imgUrl;
                    }
                }
                container.style.backgroundImage = `url('${imgUrl}')`;
            } else  {
                const video = this.$refs.videoPlayer;
                if (video) {
                    video.load();
                    video.play();
                }
                container.style.backgroundImage = '';
                container.style.background = '';
            }
        },
        getUserSex() {
            const userInfo = localStorage.getItem('userInfo');
            if(userInfo != null){
                this.sex = JSON.parse(userInfo).sex;
            }
        },
        changeSex(sex) {
            this.sex = sex
        },
        clickClassifyContainer() {
            this.$refs.websiteToolRef.closeContextMenu()
        }
    },
    watch: {
        'type': {
            handler(value) {
                this.active = value === 'ANALYSIS' ? '2' : value === 'STANDARD' ? '3' : '1'
            },
            immediate: true,
            deep: true
        },
    },
    components: {TitleBar, ClassifyLeftMenu, backgroundSettingDialog, UserDrawer, websiteTool}
}
</script>
<style lang="scss" scoped>
.classify-container {
    zoom: 80%;
}

.video-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
}

.classify-container {
    --img-bg: 66, 103, 114;
    --img-text: 233, 233, 233;
    --sidebar-opacity: 0.4;
    --alpha-bg: 255, 255, 255;

    display: flex;
    height: 100%;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, sans-serif;
    min-height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;


    .classify-left-menu {
        width: 70px;
        height:100%;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 2;
        padding-top: 20px;
        text-align: center;
        transition: transform .2s;
        color: rgba(var(--img-text), .6);
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
        background-color: rgba(var(--img-bg), var(--sidebar-opacity, .4));
    }

    .classify-content {
        margin: 0 10px 0 100px;
        flex-grow: 1;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        height:100%;
    }

    .classify-card img {
        width: 100%;
        height: 75px;
        display: flex;
        border-radius: 15px;
        background-color: white;
        justify-content: center;
        align-content: center;
        margin-top: 5px;
        border: solid 1px #29a2ce;
    }

    .card-title {
        width: 100%;
        text-align: center;
        font-size: 20px;
        margin-bottom: -12px;
        margin: 10px 0 0 0;
        color: #fff;
    }

    .classify_body {
        flex-grow: 1;
        overflow-y: auto;
        justify-content: center;
        align-items: center;
        height: 100vh;
        display: flex;
        margin-bottom: 20px;
    }

    .classify_body::-webkit-scrollbar {
        display: none;
    }

    .classify_group {
        margin-top: 30px;
    }

    .classify_row{
        display: flex;
        flex-wrap: wrap;
        margin-top: -35px;
    }

    .classify-card{
        border-radius: 5px;
        margin-right: 30px;
        margin-top: 30px;
        width: 150px;
        height: 96px;
        cursor: pointer;
        transform:translateY(0px);
        -webkit-transform:translateY(0px);
        -moz-transform:translateY(0px);
        -webkit-transition:all 0.3s ease;
        -moz-transition:all 0.3s ease;
        -o-transition:all 0.3s ease;
        transition:all 0.3s ease
    }

    .classify-card:hover{
        transform:translateY(-6px);
        -webkit-transform:translateY(-6px);
        -moz-transform:translateY(-6px);
        /* box-shadow:0 26px 40px -24px rgba(0,36,100,.3);
        -webkit-box-shadow:0 26px 40px -24px rgba(0,36,100,.3);
        -moz-box-shadow:0 26px 40px -24px rgba(0,36,100,.3) */
    }

    .date-time-search {
        //flex: 0 0 20%; /* 固定占 2/10 部分 */
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
        /* border-bottom: 1px solid #f0f0f0; */

        .date-time-item {
            margin: 8px 0;
        }
    }

    .company_name {
        font-size: 45px;
        color: #fff;
        display: flex;
        margin-top: 25px;
        align-items: flex-start;
    }

    .company_logo {
        height: 60px;
        width: 180px;
        margin-top: 2px;
        margin-right: 10px;
    }

    .date-time {
        font-size: 60px;
        color: #fff;
    }

    .current-date {
        font-size: 18px;
        color: #fff;
    }

    /deep/ .search-box {
        width: 600px;
        margin-left: 5px;
        margin-bottom: 10px;
        height: 46px;
        align-items: center;
        transition: background-color 0.3s ease;
    }

    /deep/ .search-box input::placeholder {
        color: #222;
    }

    /deep/ .search-box .el-input__inner {
        height: 46px;
        padding: 0 15px;
        border-radius: 20px;
        border: 1px solid #dcdfe6;
        font-size: 15px;
        transition: border-color 0.2s ease;
        backdrop-filter: blur(6px);
        background-color: rgba(var(--alpha-bg), 0.5)
    }

    /deep/ .search-box .el-input__inner:hover {
        border-color: #c0c4cc;
    }

    /deep/ .search-box .el-input__inner:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }

    /* 搜索按钮样式 */
    /deep/ .search-box .el-input__suffix .el-button {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        margin-left: -1px;
    }

    /deep/ .search-box .el-input__suffix {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /deep/ .search-icon {
        font-size: 20px;
        margin-right: 10px;
        cursor: pointer;
        color: #181818;
    }

    .title-text {
        height: 60px;
        line-height: 60px;
        width: fit-content;
        min-width: fit-content;
        margin-right: 20px;
        font-size: 25px;
    }

   .result_ul {
        position: absolute;
        z-index: 10;
        top: 240px;
        width: 600px;
        
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        background-color: rgba(var(--alpha-bg), .5);
        border-radius: 20px;
        transition: height .2s;
        margin-top: 8px;
        padding: 0;
        overflow: hidden;
    }

    .result_ul ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .result_ul li {
        cursor: pointer;
        padding: 0 22px;
        color: rgba(var(--alpha-color), .8);
        height: 35px;
        line-height: 33px;
        font-size: 16px;
        text-align: left;
        transition: transform 0.2s ease, padding-left 0.2s ease;
        display: flex; 
        align-items: center;

        i, img {
            margin: 0 10px;
        }

        img {
            margin: 0 5px;
            width:20px;
            height:20px;
        }
    }

    .result_ul li:hover {
        padding-left: 32px;
        background-color: #FFFFFF4D;
    }

    .classify_container {
        max-width: 1440px;
        height: 99%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/classify/classifyShowList1.vue